import React, { useState, useEffect } from 'react';
import { Card, Form, Row, Col, Select, Button, Spin, DatePicker } from 'antd';
import {
    getAllFieldCollections

} from './SavingService';
import { errHandler } from '../../helper/helper';
import { excelExport } from '../../Utils/FieldCollectionExcelExport';

const { Option, OptGroup } = Select;
const { RangePicker } = DatePicker;
const moment = require('moment');


const FieldCollectionSummary = ({
    loginPlaceId,
    products,
    districtData,
    districtName,
    divisionalId,
    branchId,
    wasamData
}) => {

    const [selectedDistricts, setSelectedDistricts] = useState([]);
    const [selectedDivisionalAreas, setSelectedDivisionalAreas] = useState([]);
    const [selectedBranches, setSelectedBranches] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [selectedDates, setSelectedDates] = useState([]);
    const [selectedWasam, setSelectedWasam] = useState([]);
    const [availableDivisionalAreas, setAvailableDivisionalAreas] = useState([]);
    const [availableBranches, setAvailableBranches] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedScope, setSelectedScope] = useState();


    // Update available branches based on selected districts
    useEffect(() => {
        let filteredDivisionalAreas = [];

        if (loginPlaceId === "2" && divisionalId) {
            // Divisional-level user: find the matching divisional area from any district
            filteredDivisionalAreas = districtData
                .flatMap(d => d.divisionalAreaDtoList || [])
                .filter(div => div.divAId === divisionalId);

            setSelectedDivisionalAreas([divisionalId]); // auto-select the one they're assigned to
        } else {
            // Normal case: based on selected districts
            filteredDivisionalAreas = districtData
                .filter(d => selectedDistricts.includes(d.districtId))
                .flatMap(d => d.divisionalAreaDtoList || []);

            // Clean up selected divisional areas
            setSelectedDivisionalAreas(prev =>
                prev.filter(did =>
                    filteredDivisionalAreas.some(d => d.divAId === did)
                )
            );
        }

        setAvailableDivisionalAreas(filteredDivisionalAreas); // <- you should set this too

    }, [selectedDistricts, districtData, loginPlaceId, divisionalId]);

    //update available branches based on selected divisional areas
    useEffect(() => {
        const filteredBranches = districtData
            .flatMap(d => d.divisionalAreaDtoList || [])
            .filter(div => selectedDivisionalAreas.includes(div.divAId))
            .flatMap(div => div.branchDtoList || []);

        setAvailableBranches(filteredBranches);

        // Clean up selected branches
        setSelectedBranches(prev =>
            prev.filter(bid =>
                filteredBranches.some(b => b.id === bid)
            )
        );
    }, [selectedDivisionalAreas, districtData]);

    let dynamicDepositTypes = [];
    if (selectedProducts.includes('ALL') || selectedProducts.length === 0) {
        // If 'ALL' is selected or no specific products are chosen, include all product names
        dynamicDepositTypes = products.map(p => p.productName?.trim()).filter(Boolean);
    } else {
        // Otherwise, map selected product IDs to their names
        dynamicDepositTypes = products
            .filter(p => selectedProducts.includes(p.productId))
            .map(p => p.productName?.trim())
            .filter(Boolean);
    }


    const onSubmit = async () => {
        setLoading(true);
        try {
            let rawData = await fieldCollections();

            if (rawData.data.length === 0) {
                errHandler("No data found for the selected criteria.");
                return; // Stop further processing
            }

            const data = rawData.data.map(item => ({
                receipt: item.receiptNo,
                accountNumber: item.accountNumber,
                type: item.productName?.trim(), // clean trailing spaces
                amount: item.amount || 0,
                gnName: item.gnName,
                fieldOfficerName: item.fieldOfficerName,
                branch:item.branchName
            }));

            const rowCategories = [...new Set(data.map(d => d.receipt))];

            const depositTypes = dynamicDepositTypes;
              const dateTimeNow = moment().format('YYYY-MM-DD_HH-mm-ss');

            excelExport({
                data,
                rowCategories,

                rowCategoryFunction: item => item.receipt,

                columnGroupKeyFunction: () => 'Deposit Types',

                columnGroups: [
                    {
                        subColumns: depositTypes.map(type => ({
                            label: type,
                            valueExtractor: item => item.type === type ? item.amount : 0,
                        })),
                    },
                ],

                fileName: "Field-Collection-Summary-"+dateTimeNow+".xlsx",
                grandTotalSubHeaders: ["Total"],

                subHeaderStyles: {
                    'MEMBER DEPOSIT': { fillColor: 'FFD966' },
                    'DIRIYAMATHA': { fillColor: 'C6E0B4' },
                },
                extraColumns: [
                    { label: "Receipt Number", valueExtractor: item => item.receipt },
                    { label: "Account Number", valueExtractor: item => item.accountNumber }
                ],
                dateRange: selectedDates.map(date => date.format('YYYY-MM-DD')),
                loginPlaceId: loginPlaceId,
            });
        } catch (err) {
            errHandler(err)
        } finally {
            setLoading(false)
        }

    }


    const fieldCollections = async () => {
        const [selectedDate, endDate] = selectedDates;
        let branchIdList= loginPlaceId==="1"?[branchId]:selectedBranches;
        let data = {
            branchIdList: branchIdList,
            productIdList: selectedProducts,
            collectType: selectedScope,
            selectedDate: selectedDate,
            endDate: endDate,
            gnIdList: selectedWasam
        }
        try {
            const res = await getAllFieldCollections(data);
            return res; // ✅ Now you're returning it from getDistrictData
        } catch (err) {
            errHandler(err);
            throw err; // optionally rethrow so caller knows it failed
        }
    }



    return (
        <div className="panel-container">
            <Card hoverable className="inner-card">
                <Form layout="vertical">
                    <Row gutter={[16, 16]}>
                        <Col span={24}>
                            <Form.Item label="colection Type">
                                <Select
                                    placeholder="colection Type"
                                    value={selectedScope}
                                    onChange={setSelectedScope}
                                    style={{ width: '100%' }}
                                >
                                    <Option value="1">Normal collections</Option>
                                    <Option value="2">Mobile app collections</Option>
                                </Select>
                            </Form.Item>
                        </Col>
                        {(loginPlaceId === "3" || loginPlaceId === "4") && (
                            <Col span={24}>
                                <Form.Item label="Select Districts">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select districts"
                                        style={{ width: '100%' }}
                                        value={selectedDistricts}
                                        onChange={setSelectedDistricts}
                                    >
                                        {districtData
                                            .filter(d => loginPlaceId === "4" ? d.districtName === districtName : true)
                                            .map(d => (
                                                <Option key={d.districtId} value={d.districtId}>
                                                    🏙️ {d.districtName}
                                                </Option>
                                            ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}

                        {(loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2") && (
                            <Col span={24}>
                                <Form.Item label="Select Divisional Areas">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select divisional areas"
                                        style={{ width: '100%' }}
                                        value={selectedDivisionalAreas}
                                        onChange={setSelectedDivisionalAreas}
                                    // disabled={selectionScope !== 'divisional' && selectionScope !== 'branch'}
                                    >
                                        {availableDivisionalAreas
                                            // .filter(d => loginPlaceId === "2" ? d.divAId === divisionalId : true)
                                            .map(d => (
                                                <Option key={d.divAId} value={d.divAId}>
                                                    🏙️ {d.divAIdName}
                                                </Option>
                                            ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}
                        {(loginPlaceId === "3" || loginPlaceId === "4" || loginPlaceId === "2") && (
                            <Col span={24}>
                                <Form.Item label="Select Branch(es)">
                                    <Select
                                        mode="multiple"
                                        placeholder="Select branches"
                                        style={{ width: '100%' }}
                                        value={selectedBranches}
                                        onChange={(values) => {
                                            if (values.includes('ALL')) {
                                                setSelectedBranches(availableBranches.map(b => b.id));
                                            } else {
                                                setSelectedBranches(values);
                                            }
                                        }}
                                        disabled={availableBranches.length === 0}
                                    >
                                        <Option key="ALL" value="ALL">
                                            🔘 Select All Branches
                                        </Option>
                                        {availableBranches.map(branch => (
                                            <Option key={branch.id} value={branch.id}>
                                                🏢 {branch.branchName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}
                        {loginPlaceId == "1" && (
                            <Col span={24}>
                                <Form.Item label="Wasam">
                                    <Select
                                        mode="multiple" value={selectedWasam} onChange={(values) => {
                                            if (values.includes('ALL')) {
                                                setSelectedWasam(wasamData.map(b => b.wastId));
                                            } else {
                                                setSelectedWasam(values);
                                            }
                                        }}
                                        disabled={wasamData.length === 0} style={{ width: '100%' }}>
                                        <Option value="ALL">All Wasam</Option>
                                        {wasamData.map((wasam) => (
                                            <Option key={wasam.wastId} value={wasam.wastId}>
                                                🏙️  {wasam.wasName}--{wasam.wasName}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        )}

                        <Col span={24}>
                            <Form.Item label="Date Range">
                                <RangePicker onChange={(values) => setSelectedDates(values)} style={{ width: '100%' }} />
                            </Form.Item>
                        </Col>

                        {/* Multi-select product */}
                        <Col span={24}>
                            <Form.Item label="Select Products">
                                <Select
                                    mode="multiple"
                                    allowClear
                                    placeholder="Select products"
                                    style={{ width: '100%' }}
                                    value={selectedProducts}
                                    onChange={(values) => {
                                        if (values.includes('ALL')) {
                                            setSelectedProducts(products.map(b => b.productId));
                                        } else {
                                            setSelectedProducts(values);
                                        }
                                    }}
                                // onChange={setSelectedProducts}
                                >
                                    <Option key="ALL" value="ALL">
                                        🔘 Select All Products
                                    </Option>
                                    {products.map(product => (
                                        <Option key={product.productId} value={product.productId}>
                                            {product.productName}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>

                        {/* Submit button */}
                        <Col span={24}>
                            <Form.Item className="generate-btn-outline">
                                <Button
                                    onClick={onSubmit}
                                    disabled={loading}
                                    className="generate-btn"
                                    style={{ textAlign: 'right' }}
                                >
                                    {loading ? <Spin /> : 'Generate Report'}
                                </Button>
                            </Form.Item>
                        </Col>
                    </Row>
                </Form>
            </Card>
        </div>
    );
};

export default FieldCollectionSummary;
